import React from 'react';
import { styled, Typography } from '@material-ui/core';

export const RowContainer = styled(({ last, ...rest }) => <div {...rest} />)(
  ({ last }) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'nowrap',
    marginBottom: last ? '0px' : '20px',
  })
);

export const RowLeftText = styled(Typography)(({ theme }) => ({
  color: theme.palette.xpl.text.secondary,
  textAlign: 'left',
  marginRight: '15px',
}));

export const RowRightText = styled(Typography)(({ theme }) => ({
  color: theme.palette.xpl.text.primary,
  textAlign: 'right',
  marginLeft: '15px',
}));
